<template>
  <v-app id="inspire">
    <div class="tips-report-wrap">
      <v-layout class="inv-top-header mb-4">
        <v-flex>
          <p class="text-uppercase caption mb-0">Reports</p>
          <h2 class="headline">Tips</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0 mb-0 mt-2"
          text
          small
          :disabled="loading || loadingCSV || items.length === 0"
          :loading="loadingCSV"
          @click="exportCSV"
          ><v-icon class="mr-1">cloud_download</v-icon> CSV</v-btn
        >
      </v-layout>

      <v-flex class="header-search-single">
        <v-container class="grid-list-md pa-0 container--fluid">
          <v-layout class="wrap xs12">  
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-menu
                ref="menu1"
                :label="`From Date`"
                v-model="menu1"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="tableData.start_date"
                    :label="`From Date`"
                    persistent-hint
                    prepend-icon="event"
                    hide-details
                    placeholder="Please Select"
                    clearable
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="tableData.start_date"
                  no-title
                  :min="minDate"
                  :max="maxDate"
                  @input="menu1 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-menu
                ref="menu2"
                :label="`To Date`"
                v-model="menu2"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="tableData.end_date"
                    :label="`To Date`"
                    persistent-hint
                    prepend-icon="event"
                    hide-details
                    placeholder="Please Select"
                    clearable
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="tableData.end_date"
                  no-title
                  :min="minDate"
                  :max="maxDate"
                  @input="menu2 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-autocomplete
                :items="staff"
                v-model="tableData.staff_id"
                label="Field Tech"
                item-text="name"
                item-value="id"
                clearable
                :loading="staffLoading"
                hide-details
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-autocomplete
                :items="clientList"
                v-model="selectedClient"
                label="Client Name"
                item-text="title"
                :item-value="i => i"
                clearable
                hide-details
                :loading="loadingClients"
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-autocomplete
                :items="types"
                v-model="tableData.tip_type"
                label="Type"
                item-text="name"
                item-value="slug"
                clearable
                hide-details
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-btn
                large
                color="primary"
                dark
                class="mx-0 mt-1 mb-2"
                style="min-width: 50px; padding: 0 10px;"
                @click="initialize(1)"
              >
                Apply
              </v-btn>
            </v-flex>
            <v-flex class="xs12 pa-0">
              <v-alert class="pa-2 mt-2" :value="!no_data.includes(dateError)" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">{{ dateError }}</span>
              </v-alert>
            </v-flex>
            <v-flex class="xs12 my-0">
              <span
                @click="resetFilters"
                class="clear-filters"
                >Reset Filters</span
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-flex v-if="!no_data.includes(tipAmount)" class="mb-3">
        <v-container class="grid-list-lg px-0 pt-0 container--fluid">
          <v-layout class="wrap xs12 bottom-card-space">
            <v-flex md3 sm6 xs12 flex-grow-1>
              <v-card>
                <div class="img-div-header-box img-header-box-name red lighten-1">
                  <v-icon large>savings</v-icon>
                </div>
                <div class="title-div-header-box">
                  <p class="text-uppercase">Field Tech Tips</p>
                  <div>{{ `$${parseFloat(tipAmount).toFixed(2)}` }}</div>
                  <p>{{ `${totalItems} client tip${totalItems === 1 ? '' : 's'}`}}</p>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20]}"
          class="elevation-1 table-org"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <span v-if="!no_data.includes(item.paid_date)">{{ item.paid_date }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-layout 
                  v-if="!no_data.includes(item.client_name)"
                  :style="
                    !no_data.includes(item.client_id) ||
                    (
                      !no_data.includes(item.commercial_client_id) &&
                      !no_data.includes(item.commercial_location_id)
                    ) ?
                    'margin-left: -14px;' : ''
                  ">
                  <v-menu
                    v-if="
                      !no_data.includes(item.client_id) ||
                      (
                        !no_data.includes(item.commercial_client_id) &&
                        !no_data.includes(item.commercial_location_id)
                      )
                    "
                    offset-y
                    bottom
                    right
                    d-inline-flex
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        v-if="!no_data.includes(item.client_id)"
                        @click="$router.push(`/client/${item.client_id}/show`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Client Details
                        </v-flex>
                      </v-list-item>
                      <v-list-item
                        v-else-if="
                          !no_data.includes(item.commercial_client_id) &&
                          !no_data.includes(item.commercial_location_id)"
                        @click="
                          $router.push(
                            `/commercial_client/${item.commercial_client_id}/show`
                          )
                        "
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Client Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.client_name }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-layout 
                  v-if="!no_data.includes(item.staff_id) && staff.some(i => i.id === item.staff_id)"
                  style="margin-left: -14px;">
                  <v-menu
                    offset-y
                    bottom
                    right
                    d-inline-flex
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="$router.push(`/staff/${item.staff_id}/show`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Field Tech Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ staff.find(i => i.id === item.staff_id).name }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.tip_amount)">{{ `$${parseFloat(item.tip_amount).toFixed(2)}` }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.tip_type)">{{ titleCase(item.tip_type) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <router-link
                  v-if="!no_data.includes(item.job_id)"
                  :to="`/dispatch_board/${item.job_id}/show`"
                  class="remove-underline"
                >{{ 
                  item.job_id 
                }}</router-link>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <router-link
                  v-if="!no_data.includes(item.invoice_number)"
                  :to="`/invoice/${item.invoice_id}`"
                  class="remove-underline"
                >{{ 
                  item.invoice_number 
                }}</router-link>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="addResServReport()">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import moment from "moment";
import { preciseMultiply, preciseDivide } from "@/common/preciseMath";
import {mapActions, mapGetters} from "vuex"

export default {
  name: "ResidentialCrossSellsReport",
  data: () => ({
    menu1: false,
    menu2: false,
    no_data: [null, "", undefined, "null"],
    headers: [
      { 
        text: "Invoice Payment Date", 
        value: "paid_date",
        sortable: false,
        align: "left", 
      },
      {
        text: "Client Name",
        value: "full_name",
        sortable: false,
        align: "left", 
      },
      {
        text: "Field Tech",
        value: "assigned_to_name",
        sortable: false,
        align: "left",
      },
      {
        text: "Tip",
        value: "tip_amount",
        sortable: false,
        align: "left",
      },
      {
        text: "Type",
        value: "tip_type",
        sortable: false,
        align: "left",
      },
      {
        text: "Job ID",
        value: "job_id",
        sortable: false,
        align: "left",
      },
      {
        text: "Invoice #",
        value: "invoice_id",
        sortable: false,
        align: "left",
      },
      // {
      //   text: "Invoice Status",
      //   value: "invoice_status",
      //   sortable: false,
      //   align: "left",
      // },
    ],
    types: [
      { name: 'Recurring', slug: 'recurring' },
      { name: 'One Time', slug: 'one_time' }
    ],
    items: [],
    options: {},
    selectedClient: null,
    totalItems: 0,
    draw: 0,
    tableData: {
      start_date: null, /* moment().startOf('month').format("YYYY[-]MM[-]DD") */
      end_date: null, /* moment().format("YYYY[-]MM[-]DD") */
      draw: 0,
      length: 10,
      page: 0,
      column: 1,
      dir: "desc"
    },
    tipAmount: null,
    residentialClients: [],
    commercialClients: [],
    loadingClients: false,
    loadingResidentialClients: false,
    loadingCommercialClients: false,
    staff: [],
    staffLoading: false,
    loadedFromDate: null,
    loadedToDate: null,
    loadedFieldTech: null,
    loadedClient: null,
    loading: false,
    addResServReportLoadin: false,
    error_code: "",
    loadingCSV: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  mounted() {
    this.initialize()
    this.getClients()
  },
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize(setPage = null) {
      if (this.no_data.includes(this.dateError)) {
        this.loading = true
        Promise.all([this.getTips(setPage), this.getStaffList()])
          .then(responses => {
            this.loading = false
          })
          .catch(errors => {
            this.loading = false
          })
      }
    },
    getTips(setPage = null) {
      return new Promise((resolve, reject) => {
        this.loading = true;
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        this.tableData.column = 1;
        if (
          !this.no_data.includes(sortBy) &&
          !this.no_data.includes(sortBy[0]) &&
          this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
        ) {
          this.tableData.column = this.headers.find(
            i => i.value === sortBy[0]
          ).sort_column;
        }
        this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

        this.tableData.length = itemsPerPage;

        this.tableData.page = page;
        this.tableData.search = this.search;
        this.tableData.draw++;
        this.draw = this.tableData.draw;

        if (!this.no_data.includes(this.selectedClient)) {
          if(this.selectedClient.type === 'residential') {
            this.tableData.client_id = this.selectedClient.id
          }
          if(this.selectedClient.type === 'commercial') {
            this.tableData.commercial_client_id = this.selectedClient.commercial_client_id
            this.tableData.commercial_location_id = this.selectedClient.commercial_location_id
          }
        } else {
          delete this.tableData.client_id
          delete this.tableData.commercial_client_id
          delete this.tableData.commercial_location_id
        }

        // let filtersForSaving = { tableData: _.cloneDeep(this.tableData), options: _.cloneDeep(this.options)}
        // filtersForSaving.tableData.draw = 0
        // this.setTableData({key: 'cleanupNotificationsReportTableData', value: filtersForSaving})

        ApiService.get("/tips_comments/all_tips", this.tableData)
          .then(response => {
            this.draw++;
            this.tipAmount = response.data.tip_amount
            this.items = response.data.tips_jobs.data;
            this.totalItems = response.data.tips_jobs.total;
            if (setPage) { this.options.page = setPage }
            this.loading = false;
            resolve()
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            reject()
          })
      })
    },
    getClients() {
      this.loadingClients = true
      Promise.all([
        this.getResidentialClients(),
        this.getCommercialClients()
      ])
      .then(responses => {
        this.loadingClients = false
      })
      .catch(error => {
        console.log(error)
        this.loadingClients = false
      })
    },
    getResidentialClients() {
      return new Promise((resolve, reject) => {
        this.loadingResidentialClients = true
        ApiService.get("/client/list", { statuses: ['active']})
          .then(response => {
            let data = response.data;
            this.residentialClients = data.clients;
            this.loadingResidentialClients = false
            resolve()
          })
          .catch(erorr => {
            console.log(error);
            this.loadingResidentialClients = false
            reject()
          });
      })
    },
    getCommercialClients() {
      return new Promise((resolve, reject) => {
        this.loadingCommercialClients = true;
          ApiService.get("/commercial/location/select")
            .then(response => {
              let data = response.data;
              this.commercialClients = data.commercial_locations;
              this.loadingCommercialClients = false;
              resolve()
            })
            .catch(erorr => {
              console.log(error);
              this.loadingResidentialClients = false
              reject()
            });
      })
    },
    resetFilters() {
      // this.tableData.start_date = moment().startOf('month').format("YYYY[-]MM[-]DD")
      // this.tableData.end_date = moment().format("YYYY[-]MM[-]DD")
      delete this.tableData.start_date
      delete this.tableData.end_date
      delete this.tableData.staff_id
      this.selectedClient = null
      delete this.tableData.client_id
      delete this.tableData.commercial_client_id
      delete this.tableData.commercial_location_id
      delete this.tableData.tip_type
      this.initialize(1)
    },
    getStaffList() {
      return new Promise((resolve, reject) => {
        this.staffLoading = true
        ApiService.get("/employee_select_list")
          .then(res => {
            this.staff = res.data.staff
            this.staffLoading = false
            resolve()
          })
          .catch(err => {
            console.log(err)
            this.staffLoading = false
            reject()
          });
      })
    },
    exportCSV() {
      if(this.no_data.includes(this.dateError)) {
        this.loadingCSV = true

        let body = {
          start_date: this.tableData.start_date,
          end_date: this.tableData.end_date,
          staff_id: this.tableData.staff_id,
          tip_type: this.tableData.tip_type
        }
        if (!this.no_data.includes(this.selectedClient)) {
          if(this.selectedClient.type === 'residential') {
            body.client_id = this.selectedClient.id
          }
          if(this.selectedClient.type === 'commercial') {
            body.commercial_client_id = this.selectedClient.commercial_client_id
            body.commercial_location_id = this.selectedClient.commercial_location_id
          }
        }

        ApiService.get("/tips_comments/all_tips_export", body)
          .then(response => {
            let items = response.data.tips_jobs

            let csvContent = "";
            let headers = [];
            let csvData = [];
            this.headers.forEach(i => {
              if (i.text != "Actions") {
                headers.push(i.text);
              }
            });
            headers.map(i => `"${i}"`);
            items.forEach(item => {
              let row = {
                paid_date: !this.no_data.includes(item.paid_date)
                  ? `"${item.paid_date}"`
                  : `""`,
                client_name: !this.no_data.includes(item.client_name)
                  ? `"${item.client_name}"`
                  : `""`,
                staff_id:
                  !this.no_data.includes(item.staff_id) && this.staff.some(i => i.id === item.staff_id)
                    ? `"${this.staff.find(i => i.id === item.staff_id).name}"`
                    : `""`,
                tip: !this.no_data.includes(item.tip_amount)
                  ? `"${parseFloat(item.tip_amount).toFixed(2)}"`
                  : `""`,
                type:
                  !this.no_data.includes(item.client_id)
                    ? `"${this.titleCase(item.tip_type)}"`
                    : `""`,
                job_id: !this.no_data.includes(item.job_id)
                  ? `"${item.job_id}"`
                  : `""`,
                invoice_number: !this.no_data.includes(item.invoice_number)
                  ? `"${item.invoice_number}"`
                  : `""`             
              }
              csvData.push(row)
            });

            csvContent += [
              headers,
              ...csvData.map(item => Object.values(item).join(",")),
              '"\n"',
              `"","","Total","${parseFloat(this.tipAmount).toFixed(2)}"`,
            ].join("\n").replace(/(^\[)|(\]$)/gm, "")

            const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const url = URL.createObjectURL(data)
            const link = document.createElement("a");
            link.setAttribute("href", url);
            let fileName = `Tips Report.csv`
            link.setAttribute(
              "download",
              fileName
            );
            link.click();
            this.loadingCSV = false
          })
          .catch(error => {
            this.vEmit({
              name: "notification", 
              data: {
                status: "error",
                text: "Oops something went wrong..."
              }
            });
            this.loadingCSV = false
          });
      }
    },
    goTo(route) {
      this.$router.push(route);
    },
    titleDateFormat() {
      return `${this.loadedFromDate} - ${this.loadedToDate}`
    },
    multiply(a, b) {
      return preciseMultiply(a, b)
    },
    divide(a, b) {
      return preciseDivide(a, b)
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    }
  },
  computed: {
    ...mapGetters(["user"]),
    clientList () {
      let residential = _.cloneDeep(this.residentialClients)
      let commercial = _.cloneDeep(this.commercialClients)
      residential = residential.map(i => ({
        ...i,
        type: 'residential',
        title: `${i.first_name} ${i.last_name}`
      }))
      commercial = commercial.map(i => ({
        ...i,
        type: 'commercial',
        title: `${i.commercial_customer_name} - ${i.commercial_location_name}`
      }))
      return [...residential, ...commercial]
    },
    minDate: function() {
      // return moment().subtract(1, "y").format('YYYY[-]MM[-]DD')
      return
    },
    maxDate: function() {
      return moment().format('YYYY[-]MM[-]DD')
    },
    dateError: function() {
      let error = ''
      if(
        !this.no_data.includes(this.tableData.start_date) &&
        !this.no_data.includes(this.tableData.end_date) &&
        moment(this.tableData.start_date).isAfter(moment(this.tableData.end_date))
      ) {
        error = 'From Date must be before To Date. Please correct selected dates.'
      } else {
        error = ''
      }
      return error
    },
    totalData: function() {
      let groupedItems = []
      let output = []
      if(this.items.length > 0) { 
        groupedItems = _.groupBy(this.items, "cross_sell_id")
        Object.values(groupedItems).forEach(i => {
          let name = null
          let quantity_total = 0
          let cross_sell_id = null
          if(i.some(s => !this.no_data.includes(s.cross_sell_name))) {
            name = i.reverse().find(s => !this.no_data.includes(s.cross_sell_name)).cross_sell_name
          }
          if(i.some(s => !this.no_data.includes(s.cross_sell_id))) {
            cross_sell_id = i.find(s => !this.no_data.includes(s.cross_sell_id)).cross_sell_id
          }
          i.forEach(el => {
            if (
              !this.no_data.includes(el.quantity) &&
              typeof parseFloat(el.quantity) === "number"
            ) {
              quantity_total += parseFloat(el.quantity);
            }
          })
          if(name !== null) {
            output.push({name, quantity_total, cross_sell_id})
          }
        })
      }
      return output 
    }
  }
};
</script>
<style>

.tips-report-wrap .header-search-single {
  padding-bottom: 20px;
}

.tips-report-wrap td a {
  text-decoration: none;
}

.tips-report-wrap .clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 13px;
}

.tips-report-wrap .table-head-text {
  white-space: normal;
  text-align: left;
  min-width: 100px;
}

.tips-report-wrap .job-status-missed {
  color: red;
}
.tips-report-wrap .job-status-completed,
.tips-report-wrap .job-status-started {
  color: forestgreen;
}
.tips-report-wrap .job-status-pending {
  color: #9e9e9e;
}
.tips-report-wrap .job-status-skipped {
  color: #2196f3;
}
.tips-report-wrap .job-status-dispatched {
  color: orange;
}

.tips-report-wrap .invoices-type-draft {
  color: #ff5252;
}

.tips-report-wrap .invoices-type-failed,
.tips-report-wrap .invoices-type-voided {
  color: #ff5252;
}

.tips-report-wrap .invoices-type-overdue {
  color: #ff6f00;
}

.tips-report-wrap .invoices-type-paid {
  color: #4caf50;
}

.tips-report-wrap .invoices-type-partially_paid {
  color: #91a5af;
}

.tips-report-wrap .invoices-type-sent {
  color: #1976d2;
}

.tips-report-wrap .invoices-type-open {
  color: #1976d2;
}

.tips-report-wrap .invoices-type-pending {
  color: #1976d2;
}

.tips-report-wrap .job-status-text {
  text-transform: uppercase;
}

.img-div-header-box {
  width: 30%;
  display: inline-block;
  height: 70px;
  background-color: lightgray;
  vertical-align: middle;
  text-align: center;
  padding: 17px 0px;
  border-top-left-radius: inherit!important;
  border-top-right-radius: 0px!important;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: inherit;
}

.img-div-header-box .v-icon {
  padding: 0px;
  color: white !important;
  border-top: none;
}

.title-div-header-box {
  display: inline-block;
  vertical-align: middle;
  padding-left: 10px;
  width: 70%;
}

.title-div-header-box p {
  font-size: x-small;
  margin: 0px;
}

.title-div-header-box h4 {
  font-weight: 400;
  font-size: 19px;
}

.title-div-header-box span {
  font-weight: 400;
  font-size: small;
}

</style>
